import React, { Component } from 'react';
import _ from 'lodash';
import ReactJson from 'react-json-view';

class Mention extends Component {
	constructor(props){
		super(props);
		this.toggle = this.toggle.bind(this);

		this.state = { expanded: false };
    }

	toggle() {
		this.setState({ expanded: !this.state.expanded });
	}

	render() {

		var dConfidence, eConfidence; 
		if(this.props.jsonResult.raw.entities[0].disambiguationResults && this.props.jsonResult.raw.entities[0].disambiguationResults[0]){

			dConfidence = this.props.jsonResult.raw.entities[0].disambiguationResults[0].score;
			if(dConfidence){
				dConfidence = dConfidence.toPrecision(4);	
			}
				
		}else{
			dConfidence = 'NoDisambiguation';
		}

		eConfidence = this.props.jsonResult.confidence;
		
		if(eConfidence){
			eConfidence = eConfidence.toPrecision(4);  	
		}

        var sentiment = null;
        if ('mention' in this.props.jsonResult.raw.entities[0]) {
            if ('sentiment' in this.props.jsonResult.raw.entities[0].mention) {
                sentiment = this.props.jsonResult.raw.entities[0].mention.sentiment;
            }
        }

        let sentimentClassName;
        if (sentiment) {
            if (sentiment.class === 'positive') {
                sentimentClassName = 'mention-sentiment-positive';
            } else if (sentiment.class === 'neutral') {
                sentimentClassName = 'mention-sentiment-neutral';
            } else if (sentiment.class === 'negative') {
                sentimentClassName = 'mention-sentiment-negative';
            }
        }

        const copyOfResults = _.cloneDeep(this.props.jsonResult.raw.entities).map((entity) => {
            if(entity.disambiguationResults) {
                entity.disambiguationResults = entity.disambiguationResults.map((disambigResult) => {
                    let copyOfDisambigResult = Object.assign({}, disambigResult);
                    delete copyOfDisambigResult.childrenVisible;
                    delete copyOfDisambigResult.hasChildren;
                    delete copyOfDisambigResult.isParent;
                    delete copyOfDisambigResult.visible;
                    delete copyOfDisambigResult.parentId;
                    return copyOfDisambigResult;
                });
            }
            if ('mention' in entity) {
                var men = entity.mention;

                // Pull attributes into the mention so that they are visible in the "mention" UI. It shows better :-)
                if ('attributes' in entity && Object.keys(entity.attributes).length > 0) {
                    men.attributes = entity.attributes;
                }

                // Pull GEO location info into the mention as well
                if ('disambiguationResults' in entity && entity.disambiguationResults.length > 0 
                    && 'attributes' in entity.disambiguationResults[0]
                    && 'location' in entity.disambiguationResults[0].attributes) {
                    men.location = entity.disambiguationResults[0].attributes.location;
                }

                return men;
            } else {
                return entity;
            }
        });

		return <div className="result">
			<h4 className="mention-title" onClick={ this.toggle }>
				<span className={ this.state.expanded ?
					'mention-toggle fa fa-chevron-down' :
					'mention-toggle fa fa-chevron-right' } />

				{ this.props.jsonResult.text } 
				<br/>
                <div className="confidence"> Extraction Confidence: 
                    <span className="confidence-value"> { eConfidence }</span>
                    {dConfidence != 'NoDisambiguation' &&
                        <span>
                            <br/>
                            <span> Disambiguation Confidence:</span>
                            <span className="confidence-value"> { dConfidence }</span>
                        </span>
                    }
                    {sentiment &&
                        <div className={ 'mention-sentiment-wrapper ' + sentimentClassName }>
                            {(sentiment.score !== undefined) &&
                                <div><span className="fa fa-angle-double-right"/> Score : {sentiment.score}</div>
                            }
                            <div><span className="fa fa-angle-double-right"/> Class : {sentiment.class}</div>
                            {('topic' in sentiment) &&
                                <div><span className="fa fa-angle-double-right"/> Topic : {sentiment.topic}</div>
                            }
                        </div>
                    }
                </div>
			</h4>

			<pre className={ this.state.expanded ? 'result-json expanded' : 'result-json' }>
                <div className="json-display">
                    <ReactJson src={copyOfResults} 
                        collapsed={2} 
                        collapseStringsAfterLength={40}
                        enableClipboard={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        name={false}
                        style={{fontSize: '11px'}}/>
                </div>
			</pre>
		</div>;
	}
};

export default Mention;
